import { useState } from 'react'

interface UseHandleDragProps {
  handleImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const useHandleDrag = ({ handleImageUpload }: UseHandleDragProps) => {
  const [dragActive, setDragActive] = useState(false)

  /**
   * ドラッグオーバーイベントのハンドラー
   * ファイルをドラッグしている最中の処理
   */
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(true)
  }
  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(true)
  }
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
  }
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const fileList = e.dataTransfer.files
      const event = { target: { files: fileList } } as React.ChangeEvent<HTMLInputElement>
      handleImageUpload(event)
    }
  }

  return { dragActive, handleDragOver, handleDragEnter, handleDragLeave, handleDrop }
}
